import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const ArrowRightIcon: FC<Props> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.33337 9.77247C3.33337 9.45606 3.5685 9.19456 3.87357 9.15317L3.95837 9.14747L14.945 9.14797L10.9759 5.19503C10.7313 4.95148 10.7304 4.55575 10.974 4.31115C11.1954 4.08878 11.5426 4.06786 11.7876 4.24888L11.8579 4.30924L16.8995 9.32924C16.9318 9.36135 16.9598 9.39609 16.9835 9.43278C16.9903 9.44383 16.9971 9.45513 17.0036 9.46665C17.0095 9.47653 17.0149 9.48679 17.02 9.49716C17.0271 9.51226 17.0339 9.52785 17.0402 9.54376C17.0453 9.55602 17.0495 9.56795 17.0534 9.57998C17.058 9.59489 17.0625 9.61078 17.0663 9.62691C17.0692 9.63817 17.0715 9.64901 17.0734 9.6599C17.0762 9.67609 17.0786 9.69285 17.0803 9.7098C17.0817 9.72273 17.0826 9.73555 17.0831 9.74837C17.0832 9.75615 17.0834 9.76429 17.0834 9.77247L17.0831 9.79668C17.0826 9.80895 17.0817 9.8212 17.0805 9.83343L17.0834 9.77247C17.0834 9.81191 17.0797 9.8505 17.0727 9.88791C17.0711 9.89685 17.0692 9.90602 17.067 9.91515C17.0626 9.93397 17.0575 9.95209 17.0516 9.96985C17.0487 9.97867 17.0453 9.9881 17.0417 9.99746C17.0344 10.0163 17.0264 10.0342 17.0177 10.0517C17.0136 10.0599 17.0091 10.0685 17.0043 10.077C16.9965 10.0909 16.9885 10.104 16.98 10.1169C16.974 10.126 16.9673 10.1355 16.9604 10.1448L16.955 10.152C16.9381 10.174 16.9199 10.1949 16.9003 10.2144L16.8996 10.215L11.8579 15.2358C11.6133 15.4794 11.2176 15.4786 10.974 15.234C10.7526 15.0116 10.7331 14.6644 10.9152 14.4201L10.9758 14.3501L14.9434 10.398L3.95837 10.3975C3.6132 10.3975 3.33337 10.1176 3.33337 9.77247Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
    </svg>
  );
};

export default ArrowRightIcon;
